import React from 'react';
import PropTypes from 'prop-types';

export default class TableCheckbox extends React.Component {

    render() {
        const {
            checked,
            onChange,
        } = this.props;

        return (
            <div className="checkbox-table">
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                />
                <div className="checkbox-table-content">
                    <div className="checkbox-table-svgs">
                        <div>
                            <SVGCheckboxUnchecked checked={checked}/>
                            <SVGCheckboxChecked checked={checked}/>
                        </div>
                        <div className="checkbox-table-aux"/>
                    </div>
                </div>
            </div>
        );
    }
}

const SVGCheckboxUnchecked = ({checked}) => (
    <svg
        viewBox="0 0 24 24"
        className={`svg-unchecked ${checked ? 'svg-unchecked-op0' : 'svg-unchecked-op1'}`}
    >
        <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>
    </svg>
);

const SVGCheckboxChecked = ({checked}) => (
    <svg
        viewBox="0 0 24 24"
        className={`svg-checked ${checked ? 'svg-checked-op1' : 'svg-checked-op0'}`}
    >
        <path
            d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
    </svg>
);

TableCheckbox.propTypes = {
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/TableCheckbox.js